(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("nl2br", [], factory);
	else if(typeof exports === 'object')
		exports["nl2br"] = factory();
	else
		root["nl2br"] = factory();
})(this, function() {
return 


// WEBPACK FOOTER //
// webpack/universalModuleDefinition